import { render } from "./SidePanelRight.vue?vue&type=template&id=18435bcc"
import script from "./SidePanelRight.vue?vue&type=script&lang=js"
export * from "./SidePanelRight.vue?vue&type=script&lang=js"

import exportComponent from "/home/circleci/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__